/**
 * @description 前台 Service 层
 * http://test.convention-docs.shuwen.com/swagger-ui.html#/
 */

import { normalizeResult } from '@/utils/tool';
import request from '@/utils/request';

const baseUrl = '/api/v1';
export interface IGetFileList {
  columnType: 'banner' | 'document' | 'news';
}
// 获取议程详情
export async function getActivityScheduleDetail(id: string) {
  const res = await request(`${baseUrl}/activity-schedule/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询议程
export async function getActivityScheduleList() {
  const res = await request(`${baseUrl}/activity-schedule/list`, {
    method: 'POST',
    body: {
      status: 1,
    },
  });
  return normalizeResult<any>(res);
}

// 获取专题视频详情
export async function getActivityDetail(id: string) {
  const res = await request(`${baseUrl}/activity/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}


// 获取论坛详情
export async function getBbsDetail(id: string) {
  const res = await request(`${baseUrl}/bbs/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询论坛
export async function getBbsList() {
  const res = await request(`${baseUrl}/bbs/list`, {
    method: 'POST',
    body: {
      status: 1,
    },
  });
  return normalizeResult<any>(res);
}

// 获取素材详情
export async function getMediaDetail(id: string) {
  const res = await request(`${baseUrl}/media/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询素材
export async function getMediaList(data: IGetFileList) {
  const res = await request(`${baseUrl}/media/list`, {
    method: 'POST',
    body: { ...data, status: 1 },
  });
  return normalizeResult<any>(res);
}

// 获取直播详情
export async function getMiceDetail(id: string) {
  const res = await request(`${baseUrl}/mice/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询直播
export async function getMiceList() {
  const res = await request(`${baseUrl}/mice/list`, {
    method: 'POST',
    body: {
      status: 1,
    },
  });
  return normalizeResult<any>(res);
}

// 获取专题详情
export async function getTopicDetail(id: string) {
  const res = await request(`${baseUrl}/topic/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询专题视频
export async function getActivityList(data: any) {
  const res = await request(`${baseUrl}/activity/list`, {
    method: 'POST',
    body: { ...data, status: 1 },
  });
  return normalizeResult<any>(res);
}

export async function getTopicList() {
  const res = await request(`${baseUrl}/topic/list`, {
    method: 'POST',
    body: {},
  });
  return normalizeResult<any>(res);
}


export async function getActivityItem(data:any) {
  const res = await request('/api/v1/activity/list', {
    method: 'POST',
    body: { ...data, status: 1 },
  });
  return normalizeResult<any>(res);
}

// 点赞
export async function giveLikeService(activityId: string, murmur: string) {
  const res = await request(`${baseUrl}/activity/good?activityId=${activityId}&id=${murmur}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 获取嘉宾详情
export async function getVipUserDetail(id: string) {
  const res = await request(`${baseUrl}/vip-user/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询嘉宾
export async function getVipUserList() {
  const res = await request(`${baseUrl}/vip-user/list`, {
    method: 'POST',
    body: {
      status: 1,
    },
  });
  return normalizeResult<any>(res);
}

// 获取展位
export async function getBoothDetail(id: string) {
  const res = await request(`${baseUrl}/booth/${id}`, {
    method: 'GET',
  });
  return normalizeResult<any>(res);
}

// 查询展位
export async function getBoothList() {
  const res = await request(`${baseUrl}/booth/list`, {
    method: 'POST',
    body: {
      status: 9,
    },
  });
  return normalizeResult<any>(res);
}
